<template>
  <Accordion class="accordion-internal" @shown="accordionShown" :elements="elements">
    <template v-slot:title="{element}">
      <span v-html="element.name"></span>
    </template>
    <template v-slot:body="{element}">
      <input v-model="elementForm.value" type="number" class="form-control" :class="{'is_invalid': errors.value}"
             :placeholder="`Количество, ${getUnitValueByCode(element.unit)}`" min="1">
      <span v-for="(error, id) in errors.value" :key="id" class="error-message">{{error}}</span>
    </template>
  </Accordion>
</template>

<script>
import UseAddElement from "@/composables/crudElements/UseAddElement";
import Accordion from "@/components/common/Accordion";

export default {
  name: "AddElementAccordionForm",
  components: {Accordion},
  setup() {
    return {
      ...UseAddElement()
    }
  },
  props: {
    elements: {
      type: Array
    },
    modelValue: {
      type: Object
    }
  },
  data() {
    return {
      elementForm: {
        value: undefined,
        element: undefined
      }
    }
  },
  methods: {
    accordionShown(e) {
      this.elementForm.element = e.target.attributes['data-id'].value
      this.elementForm.value = undefined
    },
  },
  watch: {
    modelValue: {
      handler(newVal) {
        this.elementForm = newVal
      },
      deep: true
    },
    elementForm: {
      handler(newVal) {
        this.$emit('update:modelValue', newVal)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>

.accordion-internal {
  overflow-y: visible;

  input {
    background: var(--common-background-shape);
    border: 0;

    &.is_invalid {
      border: 1px solid var(--common-red);
    }
  }

  .error-message {
    color: var(--common-red);
  }
}

.element-body {
  padding: 10px 0;
  border-bottom: 1px solid #fff;

  &:last-child {
    border-bottom: none;
  }
}
</style>
